import React, { Fragment, useMemo, useState } from 'react';
import { Particular, SubLedger } from '../../../../helpers/models/Models';
import { LoadingSpinner } from '../../../../constants/AppLoading';
import AppTable from '../../../../constants/AppTable';
import AppURL from '../../../../constants/AppURL';
import ParticularEditView from './ParticularEditView';


interface ParticularListViewListViewProps {
    results: {
        results: Particular[];
        previous: string | null;
        all: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    handleFormSuccess: ()=>void;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
}
const ParticularListView: React.FC<ParticularListViewListViewProps> = ({ results, handleFormSuccess, loading, error, setOnURL }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState<Particular | null>(null);
    const columns = [
        { header: 'Particular ID', width: 0, accessor: 'particular_id', sortable: true },
        { header: 'Particular Name', accessor: 'particular_name', sortable: true },
        { header: 'Particular Name(Nepali)', accessor: 'particular_name_nep', sortable: false },
        { header: 'Debit/Credit', accessor: 'is_credit', sortable: false },
        { header: 'Virtual PID', accessor: 'virtual_pid', sortable: false },
        { header: 'GLID', accessor: 'glid', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },
    ];

    const modifiedData = useMemo(() => {
        if (!results) return [];
        return results.results.map((item: Particular) => ({
            particular_id: item.particular_id,
            particular_name: item.particular_name,
            particular_name_nep: item.particular_name_nep,
            gl_type_cat: item.is_debit,
            is_credit: item.is_debit === 1 ? "Debit" : "Credit",
            virtual_pid: item.virtual_pid,
            glid: item.glid,
            active: item.status,
            is_debit:item.is_debit,
            status: item.status, 
            particu_for_assets:item.particu_for_assets, 
            assets_dep_pers: item.assets_dep_pers,
            sub_gl_related_id: item.sub_gl_related_id,
            branch_id: item.branch_id, 
            actions: (
                <button onClick={() => handleEdit(item)}>Edit</button>
            ),
        }));
    }, [results]);

    const handleEdit = (item: Particular) => {
        setCurrentItem(item);
        setDialogOpen(true);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }

    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onEdit={handleEdit}
                onNext={() => results?.next && setOnURL(results.next)}
                onAll={() => results?.next && setOnURL(AppURL.AccountURL + "account/particular/create/list/view/?records=end")}
                onPrev={() => results?.previous && setOnURL(results.previous)}
            />
            <ParticularEditView handleFormSuccess={handleFormSuccess} dialogOpen={dialogOpen} currentItem={currentItem} setDialogOpen={setDialogOpen} />
        </Fragment>
    );
};

export default ParticularListView;
